import axios from "@/plugins/axios";

let url = "/api/v1/portfolios/categories";

export default {
    getCategories(data){
        return axios.get(url, data).then(result => result.data);
    },
    getCategory(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    }
}
